/**
 * Impression : ouvre une fenêtre dédiée, propre, plutôt que de lutter avec
 * les feuilles de style de l'application. Utile pour la planche de codes à
 * découper et pour le procès-verbal.
 */

const STYLE = `
  * { box-sizing: border-box; }
  body { font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif; color: #111; margin: 20px; }
  h1 { font-size: 20px; margin: 0 0 4px; }
  .note { color: #444; font-size: 12px; margin: 0 0 14px; }
  .teacher { border: 2px solid #111; border-radius: 8px; padding: 12px; margin-bottom: 16px; }
  .teacher .big { display: block; font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 28px; letter-spacing: 0.1em; font-weight: 700; }
  .sheet { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
  .ticket { border: 1px dashed #666; border-radius: 8px; padding: 8px; min-height: 74px; }
  .ticket .num { display: block; font-size: 10px; color: #555; }
  .ticket .code { display: block; font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 15px; font-weight: 700; letter-spacing: 0.06em; }
  .ticket .hint { display: block; font-size: 9px; color: #666; margin-top: 4px; }
  pre { white-space: pre-wrap; font-family: ui-monospace, Menlo, Consolas, monospace; font-size: 11px; }
  @media print { body { margin: 8mm; } }
`;

export function ouvrirImpression(titre: string, corps: string): void {
  const fenetre = window.open('', '_blank');
  if (fenetre === null) {
    alert('Autorisez les fenêtres surgissantes pour lancer l’impression.');
    return;
  }
  const titreSur = titre.replace(/[<>&]/g, '');
  fenetre.document.open();
  fenetre.document.write(
    `<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>${titreSur}</title><style>${STYLE}</style></head><body>${corps}</body></html>`,
  );
  fenetre.document.close();
  fenetre.focus();
  window.setTimeout(() => fenetre.print(), 350);
}
